import { Paper, Box } from '@mui/material';
import homePlaceholder from '../assets/homeplaceholderimage.jpg';
import { useHomeAttachmentsContext } from '../contexts/HomeAttachmentsContext';
import { useChat } from '../hooks/useChat';

interface HomeMainImageProps {
  imageId?: string;
  height?: number | string;
  elevation?: number;
  maxWidth?: number | string; // Add maxWidth prop
}

const HomeMainImage = ({ 
  imageId,
  height = '250px', 
  elevation = 2,
  maxWidth = '800px' // Default maximum width
}: HomeMainImageProps) => {
  // Get the home primary image from chat context if not explicitly provided
  const { homePrimaryImage } = useChat();
  
  // Use the explicit imageId if provided, otherwise use the one from context
  const effectiveImageId = imageId || homePrimaryImage;
  
  // Use the attachment context to resolve the image URL
  const { getAttachmentById, getAttachmentUrl } = useHomeAttachmentsContext();
  
  // Resolve the image URL from the ID
  let displayImage = homePlaceholder;
  if (effectiveImageId) {
    const attachment = getAttachmentById(effectiveImageId);
    if (attachment) {
      displayImage = getAttachmentUrl(attachment);
    }
  }
  
  return (
    <Paper 
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        mb: 0.5,
        maxWidth, // Apply max width
        width: '100%',
        mx: 'auto', // Center the paper horizontally
        // Override all background-related properties
        background: 'transparent !important',
        backgroundImage: 'none !important',
        backgroundColor: 'transparent !important',
        boxShadow: elevation ? undefined : 'none !important',
      }}
      elevation={elevation}
    >
      <Box 
        sx={{
          backgroundImage: `url(${displayImage})`,
          backgroundSize: 'cover', // Switch to contain if you want to fit the image
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat', // Prevent tiling
          height: height,
          width: '100%',
          backgroundColor: 'transparent !important',
        }}
      />
    </Paper>
  );
};

export default HomeMainImage;